import React, { useEffect, useState } from "react";
import { Empty } from "antd";
import { UrlInternal } from "common/constants/endpoints";
import { useHistory, useLocation } from "react-router-dom";
import * as S from "./style";
import moment from "moment";
import { formatPrice } from "utils/formatPrice";
import InputNumberNew from "components/InputNumberNew";
import Countdown from "react-countdown";
import ModalDefault from "components/ModalDefault";
import useWindowSize, { Size } from "hooks/useWindowSize";
import ImagePopup from "components/ImagePopup";

interface Props {
  artName?: string;
  artProgress?: number;
  artTotalAmount?: number;
  artTargetAmount?: number;
  artTimeRemaining?: number;
  actionButtonDisable?: boolean;
  actionButtonTitle?: string;
  actionButtonEvent?: () => void;
  listSubImage?: any;
  goToDetail?: () => void;
  notButton?: boolean;
  errorContent?: string;
  maxStock?: number;
  maxUnit?: number;
  getQuantity?: any;
  pageSaleEnd?: boolean;
  waitingOrder?: boolean;
  eventType?: string;
  eventEndAt?: string;
  endAt?: string;
  startAt?: string;
  artTimeRemainingEvent?: number;
  artTimeRemainingV3?: number;
  data?: any;
  isPopupAllowed?: boolean;
  getTypeBuyGp?: (e: string) => void;
  onGpDetail: () => void;
}

function CardDetailOnGoing({
  actionButtonEvent,
  listSubImage = [],
  goToDetail,
  getQuantity,
  data,
  getTypeBuyGp,
  isPopupAllowed,
  onGpDetail,
}: Props) {
  const history = useHistory();
  const [currentItem, setCurrentItem] = useState<any>({
    id: 0,
    data: listSubImage[0] ?? "",
  });
  const [qty, setQty] = useState(1);
  const checkDisabledSelect =
    !data?.canOrderNormal ||
    (data?.gpVer === "V3"
      ? data?.stockForBuy <= 0
      : data?.canOrderWaiting
      ? data?.maxUnitForU1 <= 0
      : data?.stockForBuy <= 0) ||
    data?.maxUnitForU1 <= 0;
  const isMaintenance = false;
  const isActive =
    data?.canOrderNormal &&
    ((isPopupAllowed && data?.subVersion === "3.1.2") ||
      data?.subVersion === "3.1");
  const location = useLocation<{ isOwned?: boolean }>();
  const { isOwned } = location.state || {};
  const now = moment().tz("Asia/Seoul");
  const isPrev = moment(data?.startAt).tz("Asia/Seoul").isAfter(now);
  const isEnd = data?.gpVer
    ? moment(data?.gpVer === "V3" ? data?.endNormalBuyAt : data?.endAt)
        .tz("Asia/Seoul")
        .isBefore(now) && isOwned
    : true;
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 767;
  const [isPopup, setIsPopup] = useState<string>("");

  useEffect(() => {
    setCurrentItem({
      id: 0,
      data: listSubImage[0] ?? "",
    });
  }, [listSubImage]);

  const prefixO = (dataNumber: number) => {
    return dataNumber < 10 ? `0${dataNumber}` : dataNumber;
  };

  const renderModal = () => {
    if (isPrev) {
      onGpDetail();
    } else {
      return (
        <ModalDefault
          visible={true}
          setVisible={() => ""}
          title="청약 마감 안내"
          content={<div>청약이 마감되어 목록 페이지로 이동합니다.</div>}
          okEvent={() => history.push(UrlInternal.GROUP_SALE_LIST)}
          okText="확인"
          onlyOk
        />
      );
    }
  };

  const rendererIsComing = ({
    hours,
    minutes,
    seconds,
    completed,
    days,
  }: any) => {
    if (completed) {
      renderModal();
    } else {
      if (isPrev) {
        return (
          <div className="time">
            <span>시작까지</span>{" "}
            <span className="time-countdown">
              {days}일 {prefixO(hours)}시간 {prefixO(minutes)}분{" "}
              {prefixO(seconds)}초
            </span>{" "}
            <span>남았습니다.</span>
          </div>
        );
      } else {
        return (
          <div className="time">
            <span>마감까지</span>{" "}
            <span className="time-countdown">
              {days}일 {prefixO(hours)}시간 {prefixO(minutes)}분{" "}
              {prefixO(seconds)}초
            </span>{" "}
            <span>남았습니다.</span>
          </div>
        );
      }
    }
  };

  const handleShowCountDownIsComing = () => {
    if (isPrev) {
      return (
        <Countdown
          key={data.startAt}
          date={new Date(data.startAt ?? new Date()).getTime()}
          renderer={rendererIsComing}
          intervalDelay={1000}
          precision={3}
        />
      );
    } else {
      return (
        <Countdown
          key={data.endNormalBuyAt}
          date={new Date(data.endNormalBuyAt ?? new Date()).getTime()}
          renderer={rendererIsComing}
          intervalDelay={1000}
          precision={3}
        />
      );
    }
  };

  return (
    <S.SaleTogetherContainer className="sale-group">
      <div className="images">
        <div
          className="main"
          onClick={isMobile ? undefined : () => setIsPopup(currentItem.data)}
        >
          {currentItem.data ? (
            <img
              src={currentItem.data}
              alt="art-img"
              onClick={goToDetail}
              onContextMenu={(e) => {
                if (isEnd) e.preventDefault();
              }}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Image"
            />
          )}
        </div>
        <div className="sub">
          {[...listSubImage, ...Array(5 - listSubImage.length).fill(null)]
            .slice(0, 5)
            .map((v: any, i: number) =>
              v ? (
                <img
                  className={currentItem.id === i ? "active" : ""}
                  key={i}
                  src={v}
                  alt=""
                  onClick={() => setCurrentItem({ id: i, data: v })}
                />
              ) : (
                <div key={i} className="no-img"></div>
              )
            )}
        </div>
      </div>
      <div className="box">
        <div className="content">
          <div className="title">{data?.title}</div>
          <div className="price">
            <div className="item">
              <span className="key">1주당 금액</span>
              <span className="value">{formatPrice(data?.unitPrice)}원</span>
            </div>
            <div className="item-all">
              <div className="data">
                <span className="key">발행 금액</span>
                <span className="value">{formatPrice(data?.target)}원</span>
              </div>
              <span className="all">
                ({formatPrice(data?.target / data?.unitPrice)}주)
              </span>
            </div>
            <div className="item-all">
              <div className="data">
                <span className="key">모집 금액</span>
                <span className="value">
                  {formatPrice(data?.target * 0.9)}원
                </span>
              </div>
              <span className="all">
                ({formatPrice((data?.target * 0.9) / data?.unitPrice)}주)
              </span>
            </div>
          </div>
        </div>
        {!isEnd && (
          <>
            <div className="line"></div>
            <div className="box-select">
              <div className="item-select">
                <div className="item-select-text">신청수량</div>
                <InputNumberNew
                  max={Math.min(
                    data?.gpVer === "V3"
                      ? data?.stockForBuy
                      : data?.canOrderWaiting
                      ? data?.maxUnitForU1
                      : data?.stockForBuy,
                    data?.maxUnitForU1
                  )}
                  disabled={checkDisabledSelect}
                  onChange={(e) => {
                    getQuantity(e);
                    setQty(e);
                  }}
                  value={qty}
                  handleUp={() => {
                    let value = qty + 1;
                    getQuantity(value);
                    setQty(value);
                  }}
                  handleDown={() => {
                    let value = qty - 1;
                    getQuantity(value);
                    setQty(value);
                  }}
                />
                <div className="item-select-qty">주</div>
              </div>
              <div className="shinhan-text">
                최대가능 :{" "}
                {formatPrice(
                  Math.min(
                    data?.gpVer === "V3"
                      ? data?.stockForBuy
                      : data?.canOrderWaiting
                      ? data?.maxUnitForU1
                      : data?.stockForBuy,
                    data?.maxUnitForU1
                  )
                )}
                주
              </div>
            </div>
            <div className="box-total">
              <div className="title-total">신청금액 :</div>
              <div className="sub-total">총 {qty}주</div>
              <span className="price-total">
                {formatPrice(data?.unitPrice * qty)}
              </span>
              원
            </div>
            <div className="timer">
              {handleShowCountDownIsComing()}
              {isPrev ? (
                <div className="time-end">
                  (<span>청약 시작일</span> :{" "}
                  {moment(data?.startAt).format("YYYY.MM.DD HH:mm A")})
                </div>
              ) : (
                <div className="time-end">
                  (<span>청약 마감일</span> :{" "}
                  {moment(data?.endNormalBuyAt).format("YYYY.MM.DD HH:mm A")})
                </div>
              )}
            </div>

            {isMaintenance && data?.subVersion === "3.1.2" ? (
              <div className="btn disabled">증권사 점검중</div>
            ) : (
              <div
                className={`btn${isActive ? "" : " disabled"}`}
                onClick={() => {
                  if (isActive) {
                    actionButtonEvent?.();
                    getTypeBuyGp?.("NORMAL");
                  }
                }}
              >
                {data?.canOrderNormal
                  ? "청약신청"
                  : isPrev
                  ? "청약예정"
                  : "청약완료"}
              </div>
            )}

            <div className="info">
              {!isPopupAllowed && data?.subVersion === "3.1.2" && (
                <>
                  * 브라우저에서 팝업 차단이 설정되어 있는지 확인한 후,
                  새로고침해주세요. *
                </>
              )}
            </div>
          </>
        )}
      </div>
      {isPopup && (
        <div className="image-popup">
          <ImagePopup
            okEvent={() => setIsPopup("")}
            visible={isPopup.length > 0}
            content={
              <span>
                <img src={isPopup} alt="img"></img>
              </span>
            }
          />
        </div>
      )}
    </S.SaleTogetherContainer>
  );
}

export default CardDetailOnGoing;
